<template>
 <div class="col mb-4">
  <div class=" ">
    <img :src="product.image_url" class="card-img-top w-50 h-50 mb-1  rounded mx-auto d-block" :alt="product.name">
    <div class="card-body">
        <h5 class="card-title text-left font-weight-bolder">{{product.name}}</h5>
        <p class="card-text text-left ">Rp. {{product.price}},00</p>
        <p class="card-text text-left ">Tersisa {{product.stock}}</p>
        <button v-if="cekLogin" class="card-text text-left btn btn-outline-success" @click.prevent="addCart"> Add To Cart </button>
    </div>
  </div>
 </div>
</template>

<script>
export default {
    name: 'CartProduct',
    props: ['product'],
    computed : {
      cekLogin () {
        return localStorage.getItem("access_token")
      }
    }
    ,
    methods : {
      addCart (productId) {
        this.$store.dispatch('addCart', this.product.id)
      }
    }
}
</script>

<style>

</style>